import { useRef } from 'react';
import classNames from 'classnames';
import { Col, Row, Carousel } from 'antd';
import { CarouselRef } from 'antd/es/carousel';
import LatestUpdatesResponse from '@Types/api/strapi/LatestUpdatesResponse';
import { CarouselItem, CarouselMainItem } from '../components';

import commonStyle from '../../common-desktop-styles.module.css';
import styles from './component-styles.module.css';

interface LatestUpdatesDesktopProps {
  latestUpdates: LatestUpdatesResponse | undefined;
}

const LatestUpdatesDesktop: React.FC<LatestUpdatesDesktopProps> = ({
  latestUpdates,
}) => {
  const sliderRef = useRef<CarouselRef>(null);

  const handleClick = (index: number): void => {
    if (sliderRef?.current) {
      sliderRef.current.goTo(index);
    }
  };

  return (
    <div
      className={classNames(
        commonStyle.infoBlock,
        styles.latestUpdatesSection,
        'trojan-glassphormism-box trojan-glassphormism-box-shadow'
      )}
    >
      <div className={commonStyle.header}>
        <div className={commonStyle.caption}>Latest Updates</div>
      </div>
      {latestUpdates?.data.length && (
        <Row gutter={24} className={styles.annoucement}>
          <Col span={16}>
            <Carousel ref={sliderRef} dotPosition="left" autoplay fade>
              {latestUpdates?.data.map((news) => (
                <CarouselMainItem
                  key={news.id}
                  publishedAt={news.attributes.publishedAt}
                  description={news.attributes.newsPostDescription}
                  imageSrc={
                    news.attributes.newsPostImage.data[0].attributes.url
                  }
                  newsType={news.attributes.newsType}
                  title={news.attributes.newsPostTitle}
                />
              ))}
            </Carousel>
          </Col>
          <Col span={8} className={styles.shorterPostContent}>
            {latestUpdates?.data.map((news, index) => (
              <CarouselItem
                key={news.id}
                publishedAt={news.attributes.publishedAt}
                description={news.attributes.newsPostDescription}
                imageSrc={
                  news.attributes.newsPostImage.data[0].attributes.formats
                    .thumbnail.url
                }
                newsType={news.attributes.newsType}
                onClick={() => handleClick(index)}
              />
            ))}
          </Col>
        </Row>
      )}
    </div>
  );
};

export default LatestUpdatesDesktop;
